module.exports = __webpack_public_path__ + "img/All-Terrain-Boots.db284d3b.jpg";